import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Form, FormikProvider, useFormik } from 'formik';
import { toast } from 'react-toastify';
// @mui
import { Link, Stack, IconButton, InputAdornment, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/iconify';
import { login } from './LoginAction';
import { activateAccountService } from '../../../services/activateAccount';
import { checkComponentPermission } from '../../../utils/share';
import { getProfile } from '../accountSettings/AccountAction';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    password: Yup.string().required('Password is required'),
    // .matches(
    //   PASSWORD_REGEX,
    //   'Password should contain atleast one number and one special character having length between 6 To 16 characters.'
    // ),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: LoginSchema,
    onSubmit: (values) => {
      dispatch(login(values))
        .then(({ value }) => {
          if (value.data.status === 'success') {
            dispatch(getProfile());
            toast.success('Login Successful');
            if (checkComponentPermission('PROJECT_DASHBOARD')) {
              navigate('/project-dashboard', { replace: true });
            } else {
              navigate('/', { replace: true });
            }
          } else {
            toast.error('Invalid email or password');
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message ?? 'something went wrong please try again later');
        })
        .finally(() => {
          setSubmitting(false);
        });
    },
  });

  const { errors, touched, handleSubmit, isSubmitting, setSubmitting, getFieldProps } = formik;

  const activateAccount = async () => {
    try {
      const response = await activateAccountService(params?.token);
      toast.success(response?.data?.message);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    dispatch({ type: 'EMPTY_STORE_STATE' });
    if (params?.token) {
      activateAccount();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <FormikProvider value={formik}>
        <Form onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              focused
              name="email"
              label="Email address"
              {...getFieldProps('email')}
              error={touched.email && Boolean(errors.email)}
              helperText={touched.email && errors.email}
            />

            <TextField
              focused
              name="password"
              label="Password"
              {...getFieldProps('password')}
              error={touched.password && Boolean(errors.password)}
              helperText={touched.password && errors.password}
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="end" sx={{ my: 2 }}>
            <Link variant="subtitle2" underline="hover" href="/auth/forgotpassword">
              Forgot password?
            </Link>
          </Stack>

          <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
            Login
          </LoadingButton>
        </Form>
      </FormikProvider>
    </>
  );
}
